export default __webpack_public_path__ + "static/media/946.2c7334a3.png";